import { createRouter, createWebHistory } from 'vue-router';
import Home from '../components/pages/home/Home.vue';
import Login from '../components/pages/loginregister/LoginRegister.vue';
import Contact from '../components/pages/contact/ContactUs.vue';
import OpenOrders from '../components/pages/openorders/OpenOrders.vue';
import OrderDetails from '../components/pages/orderdetails/OrderDetails.vue';
import OrderHistory from '../components/pages/orderhistory/OrderHistory.vue';
import ShippedOrders from '../components/pages/shippedorders/ShippedOrders.vue';
import OrderParts from '../components/pages/orderparts/OrderParts.vue';
import ProductDetail from '../components/pages/productdetail/ProductDetail.vue';
import Promotions from '../components/pages/promotions/Promotions.vue';
import SavedOrders from '../components/pages/savedorders/SavedOrders.vue';
import AccountGarage from '../components/pages/accountgarage/AccountGarage.vue';
import AccountAddresses from '../components/pages/accountaddresses/AccountAddresses.vue';
import AccountEditAddress from '../components/pages/accounteditaddress/AccountEditAddress.vue';
import AccountPassword from '../components/pages/accountpassword/AccountPassword.vue';
import AccountPayments from '../components/pages/accountpayments/AccountPayments.vue';
import ShippingPolicy from '../components/pages/shippingpolicy/ShippingPolicy.vue';
import ReturnsPolicy from '../components/pages/returnpolicy/ReturnPolicy.vue';
import About from '../components/pages/about/About.vue';
import Cart from '../components/pages/cart/Cart.vue';
import Category from '../components/pages/category/Category.vue';
import CategoryDrilldown from '../components/pages/categorydrilldown/CategoryDrilldown.vue';
import CategorySearch from '../components/pages/categorysearch/CategorySearch.vue';
import PartsDiagram from '../components/pages/partsdiagramgroup/PartsDiagramGroup.vue';
import CheckOutB2B from '../components/pages/checkoutb2b/CheckoutB2B.vue';
import CheckOutB2C from '../components/pages/checkoutb2c/CheckoutB2C.vue';
import CheckStock from '../components/pages/checkstock/CheckStock.vue';
import SelectParts from '../components/pages/selectparts/SelectParts.vue';
import CompareSubstitutes from '../components/pages/comparealternates/CompareAlternates.vue';
import OrderSuccess from '../components/pages/ordersuccess/OrderSuccess.vue';
import SearchResults from '../components/pages/searchresults/SearchResults.vue';
import KeywordSearchResults from '../components/pages/searchresults/KeywordSearchResults.vue';
import CardConnect from '../components/pages/cardconnect/CardConnect.vue';
import BuyersGuide from '../components/pages/buyersguide/BuyersGuide.vue';
import Interchange from '../components/pages/interchange/Interchange.vue';
import InterchangeSearch from '../components/pages/interchangesearch/InterchangeSearch.vue';
import AccountSummary from '../components/pages/accountsummary/AccountSummary.vue';
import AccountStatements from '../components/pages/accountstatements/AccountStatements.vue';
import InvoicesOpen from '../components/pages/invoicesopen/InvoicesOpen.vue'
import InvoicesPaid from '../components/pages/invoicespaid/InvoicesPaid.vue'

import Invoice from '../components/pages/invoice/Invoice.vue'
import AccountSearch from '../components/pages/accountsearch/AccountSearch.vue'
import AccountPaymentHistory from '../components/pages/accountpaymenthistory/AccountPaymentHistory.vue'
import StockOrder from '../components/pages/stockorder/StockOrder.vue'
import KitGroup from '../components/pages/kit-group/KitGroup.vue'
import KitCatalog from '../components/pages/kit-catalog/KitCatalog.vue'
import NotFound from '../components/pages/genericpages/404.vue'

// whi pages
import WHIProductDetail from '../components/pages/whi-product-detail/WHIProductDetail.vue';

// partslinks pages
import PartsLinkDetails from '../components/pages/partslink-details/PartsLinkDetails.vue';

import ReturnList from '../components/pages/return-list/ReturnList';
import ReturnItems from '../components/pages/returnitems/ReturnItems';
import ReturnItemsSimple from '../components/pages/returnsimple/ReturnItemsSimple';
import ReturnItemsApproved from '../components/pages/returnapproved/ReturnItemsApproved';

import DynamicPage from '../components/pages/dynamicpage/DynamicPage.vue';

import store from '../store/index.js';

const routes = [
    { path: '/', redirect: '/home' },
    { path: '/home', name: 'Home', component: Home },
    { path: '/login', name: 'Login', component: Login },
    { path: '/contact', name: 'Contact', component: Contact },
    { path: '/account-open-orders', name: 'OpenOrders', component: OpenOrders },
    // { path: '/account-order-details', name: 'OrderDetails', component: OrderDetails },
    { path: '/account-orders', name: 'OrderHistory', component: OrderHistory },
    {
        path: '/account-orders/:order',
        name: 'OrderDetails',
        component: OrderDetails,
        props: true
    },
    { path: '/account-shipped-orders', name: 'ShippedOrders', component: ShippedOrders },
    { path: '/order-parts', name: 'OrderParts', component: OrderParts },
    // { path: '/product-detail', name: 'ProductDetail', component: ProductDetail },
    {
        path: '/part/:manufacturer/:partnumber/:mfgSeo?/:partSeo?',
        name: 'ProductDetail',
        component: ProductDetail,
        props: true
    },
    { path: '/promotions', name: 'Promotions', component: Promotions },
    { path: '/account-saved-qwik-orders', name: 'SavedOrders', component: SavedOrders },
    { path: '/account-garage', name: 'AccountGarage', component: AccountGarage },
    { path: '/account-addresses/:action?', name: 'AccountAddresses', component: AccountAddresses },
    { path: '/account-edit/:type', name: 'AccountEditAddress', component: AccountEditAddress },
    { path: '/account-password', name: 'AccountPassword', component: AccountPassword },
    { path: '/account-saved-payment-methods', name: 'AccountPayments', component: AccountPayments },
    { path: '/account-statements', name: 'AccountStatements', component: AccountStatements },
    { path: '/account-summary', name: 'AccountSummary', component: AccountSummary },
    { path: '/shipping-policy', name: 'ShippingPolicy', component: ShippingPolicy },
    { path: '/returns-policy', name: 'ReturnsPolicy', component: ReturnsPolicy },
    { path: '/about-us', name: 'About', component: About },
    { path: '/cart', name: 'Cart', component: Cart },
    { path: '/category', name: 'Category', component: Category },
    { 
        // path: '/category-drilldown', 
        path: '/category/:categoryUri', 
        name: 'CategoryDrilldown', 
        component: CategoryDrilldown,
        props: true,
    },
    { 
        // path: '/category-drilldown', 
        // path: '/category-search/:categoryUri/:categoryDesc/:categoryUri2?', 
        path: '/category-search/:level/:categoryUri1/:categoryUri2?/:categoryUri3?/:categoryUri4?/:categoryUri5?/:categoryUri6?/:categoryUri7?/:categoryUri8?/:categoryUri9?/:seoUri1?/:seoUri2?/:seoUri3?/:seoUri4?/:seoUri5?/:seoUri6?/:seoUri7?/:seoUri8?/:seoUri9?', 
        name: 'CategorySearch', 
        component: CategorySearch,
        props: true,
    },
    { 
        // path: '/category-drilldown', 
        // path: '/category/:level/:categoryUri', 
        path: '/category/:level/:categoryUri1/:categoryUri2?/:categoryUri3?/:categoryUri4?/:categoryUri5?/:categoryUri6?/:categoryUri7?/:categoryUri8?/:categoryUri9?/:seoUri1?/:seoUri2?/:seoUri3?/:seoUri4?/:seoUri5?/:seoUri6?/:seoUri7?/:seoUri8?/:seoUri9?', 
        name: 'CategoryDrilldown', 
        component: CategoryDrilldown,
        props: true,
        beforeEnter: (to, from, next) => {
            // Do your logic here.
            if(from.name != 'CategoryDrilldown' && from.name != 'Category' ){
                store.dispatch('setCat_faceted_filter', null);
            }
            next();
        }
    },
    {
        path: '/sub-category/:level/:categoryUri1/:categoryUri2?/:categoryUri3?/:categoryUri4?/:categoryUri5?/:categoryUri6?/:categoryUri7?/:categoryUri8?/:categoryUri9?/:categoryUri10?/:seoUri1?/:seoUri2?/:seoUri3?/:seoUri4?/:seoUri5?/:seoUri6?/:seoUri7?/:seoUri8?/:seoUri9?/:seoUri10?', 
        name: 'PartsDiagram', 
        component: PartsDiagram, 
        props: true, 
    },
    // { path: '/category-drilldown', name: 'CategoryDrilldown', component: CategoryDrilldown },
    // { path: '/parts-diagram-group', name: 'PartsDiagram', component: PartsDiagramGroup },
    { path: '/checkout-business', name: 'CheckOutB2B', component: CheckOutB2B },
    { path: '/checkout', name: 'CheckOutB2C', component: CheckOutB2C },
    // { path: '/order-entry-check-stock', name: 'CheckStock', component: CheckStock },
    {
        path: '/order-entry-check-stock/:manufacturer/:partnumber',
        name: 'CheckStock',
        component: CheckStock,
        props: true
    },
    { path: '/select-parts-drilldown', name: 'SelectParts', component: SelectParts },
    { 
        path: '/compare-substitutes/:manufacturer/:partnumber', 
        name: 'CompareSubstitutes', 
        component: CompareSubstitutes, 
        props: true 
    },
    { path: '/order-success', name: 'OrderSuccess', component: OrderSuccess },
    // { path: '/search', name: 'SearchResults', component: SearchResults },
    { path: '/search-results/:search_type?/:keyword?', name: 'SearchResults', component: SearchResults, props: true },
    { 
        // path: '/keyword-search-results/:keyword', 
        path: '/keyword-search-results', 
        name: 'KeywordSearchResults', 
        component: KeywordSearchResults, 
        props: true, 
    },
    { path: '/card-connect', name: 'CardConnect', component: CardConnect },
    { 
        path: '/buyers-guide/:QMFRCD/:QITEMC/:QTYPEC?', 
        name: 'BuyersGuide', 
        component: BuyersGuide,
        props: true,
    },
    { 
        path: '/interchange/:sku', 
        name: 'Interchange', 
        component: Interchange, 
        props: true, 
    },
    { path: '/interchange-search', name: 'InterchangeSearch', component: InterchangeSearch },
    
    { path: '/invoice/:rmloc/:rmrefn', name: 'Invoice', component: Invoice },
    { path: '/invoices-open', name: 'InvoicesOpen', component: InvoicesOpen },
    { path: '/invoices-paid', name: 'InvoicesPaid', component: InvoicesPaid },

    { path: '/account-search', name: 'AccountSearch', component: AccountSearch },
    { path: '/account-payment-history', name: 'AccountPaymentHistory', component: AccountPaymentHistory },
    { path: '/stock-order', name: 'StockOrder', component: StockOrder },

    { path: '/kit-group/:manufacturer/:kitnumber', name: 'KitGroup', component: KitGroup, props: true },
    { path: '/kit-catalog', name: 'KitCatalog', component: KitCatalog, props: true },
    {
        path: '/whi-product-detail',
        name: 'WHIProductDetail',
        component: WHIProductDetail,
        props: true
    },
    {
        path: '/partslink-details/:manufacturer/:partnumber/:mfgSeo?/:partSeo?',
        name: 'PartsLinkDetails',
        component: PartsLinkDetails,
        props: true
    },

    // generic pages
    { path: '/404', name: 'NotFound', component: NotFound },
    { path: '/return-list', name: 'ReturnList', component: ReturnList },
    { path: '/return-simple', name: 'ReturnItemsSimple', component: ReturnItemsSimple },
    { path: '/return-items/:saved?', name: 'ReturnItems', component: ReturnItems, props: true },
    { path: '/return-items-approved', name: 'ReturnItemsApproved', component: ReturnItemsApproved },
    
    { path: '/page/:page/:location', name: 'DynamicPage', component: DynamicPage },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        return { top: 0, left: 0 }
    }
});

router.beforeEach((to, from, next) => {
    // console.log(to);
    if (to.matched.length >  0){
        // this.$ga.page({
        //     page: to.fullPath,
        //     title: to.name,
        // });
        next();
    }
    else{
        // next();
        next('/404'); 
    }

});

export default router